import React from 'react'
import SimpleBanner from '../../components/common/SimpleBanner'
import BlogSection from '../../components/User/Home/BlogSection'

const Events = () => {
  return (
    <div>
        <SimpleBanner title='News & Events' subheading='Home > Company > News & Events' />
        <BlogSection/>
    </div>
  )
}

export default Events